import nieuweSportclubApi from "../../../api/nieuweSportclubApi";
import mergeDeep from "../../../util/mergeDeep.js";
import assign from 'object-assign';

export default class SporttakPageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		let context = this.context;
		context.props.loadLayout("Meld nieuwe sportclub");

		context.setState({
			model: context.props.storeModel,
			checkedSporttakken: context.props.storeModel.sporttakken ? context.props.storeModel.sporttakken.map(s => s.id) : []
		});
	}

	flatten(sporttakken, sporttakkenFlattened) {
		sporttakken.forEach((sporttak) => {
			sporttakkenFlattened.push(sporttak);
			if (sporttak.subsporttakken && sporttak.subsporttakken.length) this.flatten(sporttak.subsporttakken, sporttakkenFlattened);
		});

		return sporttakkenFlattened;
	}

	goToNext() {
		const context = this.context;
		const state = context.state;

		let searchresults = state.searchresults.map(x => mergeDeep({}, x));
		if (searchresults.length === 0) {
			this.redirector.goTo("/nieuweSportclub/doelgroep");
		}
		else {
			const context = this.context;
			const state = context.state;
			let checkedSporttakken = assign([], state.checkedSporttakken);
            let newSporttakken = state.unsavedCheckedSporttakken.filter(el => checkedSporttakken.indexOf(el) === -1); // only sporttakken not in checked
			checkedSporttakken = checkedSporttakken.concat(newSporttakken);
			const checkedSearchResults = searchresults.filter(s => checkedSporttakken.indexOf(s.id) > -1);
			let model = mergeDeep({}, state.model);
			let sporttakken = assign([], model.sporttakken);

			checkedSearchResults.map(s => {
				if (sporttakken.map(m => m.id).indexOf(s.id) === -1) {
					sporttakken.push(s);
				}

				const moedersporttak = sporttakken.find(m => m.id === s.moederId);
				if (moedersporttak) {
					const subsporttak = moedersporttak.subsporttakken.find(sub => sub.id === s.id);

					if (!subsporttak) {
						moedersporttak.subsporttakken.push(s);
					}
				}
			});

			model.sporttakken = sporttakken;

			context.setState({
				model,
				filter: "",
				searchresults: [],
				totalSearchResults: -1,
				searchLevel: -1,
				checkedSporttakken,
				unsavedCheckedSporttakken: []
			});
		}
	}

	changeFilter(event) {
		const context = this.context;
		const value = event.target.value;

		context.setState({
			filter: value
		});
	}

	change(event) {
		const value = event.target.checked;
		const id = event.target.name.split('_')[0];
		const moederId = event.target.name.split('_')[1];
		const context = this.context;
		const state = context.state;

		let searchresults = state.searchresults.map(x => mergeDeep({}, x));
		searchresults = this.flatten(searchresults, []);
		const unsavedCheckedSporttakken = assign([], state.unsavedCheckedSporttakken);

		if (value) {
			if (unsavedCheckedSporttakken.indexOf(id) === -1) {
				unsavedCheckedSporttakken.push(id);
			}
		}
		else {
			if (unsavedCheckedSporttakken.indexOf(id) !== -1) {
				const index = unsavedCheckedSporttakken.indexOf(id);
				unsavedCheckedSporttakken.splice(index, 1);
			}
		}

		if (moederId !== '00000000-0000-0000-0000-000000000000') {
			this.setRootCheckbox(moederId, unsavedCheckedSporttakken);
		}

		this.setChildCheckboxes(id, unsavedCheckedSporttakken);

		context.setState({
			searchresults,
			totalSearchResults: searchresults.length,
			sporttakFilterHasFocus: false,
			unsavedCheckedSporttakken
		});
	}

	setRootCheckbox(moederId, checkedSporttakken) {
		const context = this.context;
		const state = context.state;

		let sporttakken = state.searchresults.map(x => mergeDeep({}, x));

		while (sporttakken.map(s => s.id).indexOf(moederId) === -1 && moederId !== '00000000-0000-0000-0000-000000000000') {
			sporttakken.map(st => {
				if (st.subsporttakken) {
					sporttakken = sporttakken.concat(...st.subsporttakken);
				}
			});
		}

		const moedersporttak = sporttakken.filter(s => s.id === moederId)[0];

		if (moedersporttak) {
			const checkedSubsporttakken = moedersporttak.subsporttakken && moedersporttak.subsporttakken.filter(s => checkedSporttakken.indexOf(s.id) > -1);

			if (checkedSubsporttakken && checkedSubsporttakken.length > 0) {
				if (checkedSporttakken.indexOf(moedersporttak.id) === -1) {
					checkedSporttakken.push(moedersporttak.id);
				}
			}
			else {
				if (checkedSporttakken && checkedSporttakken.indexOf(moedersporttak.id) !== -1) {
					const index = checkedSporttakken.indexOf(moedersporttak.id);
					checkedSporttakken.splice(index, 1);
				}
			}
		}

		if (moedersporttak && moedersporttak.moederId !== '00000000-0000-0000-0000-000000000000') {
			this.setRootCheckbox(moedersporttak.moederId, checkedSporttakken);
		}
	}

	setChildCheckboxes(id, checkedSporttakken) {
		const context = this.context;
		const state = context.state;

		let sporttakken = state.searchresults.map(x => mergeDeep({}, x));

		while (sporttakken.map(s => s.id).indexOf(id) === -1) {
			sporttakken.map(st => {
				if (st.subsporttakken) {
					sporttakken = sporttakken.concat(...st.subsporttakken);
				}
			});
		}

		const sporttak = sporttakken.filter(s => s.id === id)[0];

		if (checkedSporttakken.indexOf(sporttak.id) > -1) {
			sporttak.subsporttakken.map((subsporttak) => {
				if (checkedSporttakken.indexOf(subsporttak.id) === -1) {
					checkedSporttakken.push(subsporttak.id);
				}
			});
		}
		else {
			sporttak.subsporttakken.map((subsporttak) => {
				if (checkedSporttakken.indexOf(subsporttak.id) !== -1) {
					const index = checkedSporttakken.indexOf(subsporttak.id);
					checkedSporttakken.splice(index, 1);
				}
			});
		}

		if (sporttak.subsporttakken) {
			sporttak.subsporttakken.map((subsporttak) => {
				this.setChildCheckboxes(subsporttak.id, checkedSporttakken);
			});
		}
	}

	removeRoot(moederId, checkedSporttakken) {
		const context = this.context;
		const state = context.state;

		let model = mergeDeep({}, state.model);
		let sporttakken = assign([], model.sporttakken);

		while (sporttakken.map(s => s.id).indexOf(moederId) === -1 && moederId !== '00000000-0000-0000-0000-000000000000') {
			sporttakken.map(st => {
				if (st.subsporttakken) {
					sporttakken = sporttakken.concat(...st.subsporttakken);
				}
			});
		}

		const moedersporttak = sporttakken.filter(s => s.id === moederId)[0];

		if (moedersporttak) {
			const checkedSubsporttakken = moedersporttak.subsporttakken && moedersporttak.subsporttakken.filter(s => checkedSporttakken.indexOf(s.id) > -1);

			if ((!checkedSubsporttakken || checkedSubsporttakken.length === 0) && checkedSporttakken.indexOf(moedersporttak.id) !== -1) {
				const index = checkedSporttakken.indexOf(moedersporttak.id);
				checkedSporttakken.splice(index, 1);
			}

			if (moedersporttak.moederId !== '00000000-0000-0000-0000-000000000000') {
				this.removeRoot(moedersporttak.moederId, checkedSporttakken);
			}
		}


	}

	removeChildren(id, checkedSporttakken) {
		const context = this.context;
		const state = context.state;

		let model = mergeDeep({}, state.model);
		let sporttakken = assign([], model.sporttakken);

		while (sporttakken.map(s => s.id).indexOf(id) === -1) {
			sporttakken.map(st => {
				if (st.subsporttakken) {
					sporttakken = sporttakken.concat(...st.subsporttakken);
				}
			});
		}

		const sporttak = sporttakken.filter(s => s.id === id)[0];

		sporttak.subsporttakken.map((subsporttak) => {
			if (checkedSporttakken.indexOf(subsporttak.id) !== -1) {
				const index = checkedSporttakken.indexOf(subsporttak.id);
				checkedSporttakken.splice(index, 1);
			}
		});

		if (sporttak.subsporttakken) {
			sporttak.subsporttakken.map((subsporttak) => {
				this.removeChildren(subsporttak.id, checkedSporttakken);
			});
		}
	}

	search() {
		const context = this.context;
		const state = context.state;
		const props = context.props;
		const ajaxActions = props.ajaxActions;
		const filter = state.filter;

		if (filter) {
			ajaxActions.started();
			nieuweSportclubApi.listSporttakkenByFilter(filter)
				.then((response) => {
					ajaxActions.ended();
					this.processSearchModel(response.data);
				})
				.catch((ex) => {
					ajaxActions.failed();
					props.throwException(ex, true);
				});
		}
	}

	processSearchModel(model) {
		const context = this.context;
		const searchresults = model.sporttakken.map(x => mergeDeep({}, x));
		const searchLevel = -1;

		context.setState({
			searchresults,
			searchLevel,
			totalSearchResults: searchresults.length,
            unsavedCheckedSporttakken: []
		});
	}

	goToPrev() {
		const context = this.context;
		const state = context.state;

		let searchresults = state.searchresults.map(x => mergeDeep({}, x));
		const checkedSporttakken = state.model.sporttakken.map(m => m.id);

		if (searchresults.length === 0) {
			this.redirector.goTo("/nieuweSportclub/adres");
		}
		else {
			context.setState({
				searchresults: [],
				searchLevel: -1,
				totalSearchResults: -1,
				filter: "",
				checkedSporttakken,
				unsavedCheckedSporttakken: []
			});
		}
	}

	increaseLevel(currentLevel) {
		const context = this.context;
		let level = context.state.level;

		if (level < currentLevel || level === -1) {
			context.setState({
				level: currentLevel
			});
		}
	}

	increaseSearchLevel(currentLevel) {
		const context = this.context;
		let level = context.state.searchLevel;

		if (level < currentLevel || level === -1) {
			context.setState({
				searchLevel: currentLevel
			});
		}
	}

	confirmDeleteSporttakModal() {
		const context = this.context;
		const state = this.context.state;
		let checkedSporttakken = assign([], state.checkedSporttakken);
		let model = mergeDeep({}, state.model);
		let sporttakken = assign([], model.sporttakken);

		//remove it from the list
		checkedSporttakken = checkedSporttakken.filter(x => x !== state.sporttakToDelete);

		const sporttak = sporttakken.find(m => m.id === state.sporttakToDelete);

		if (sporttak.moederId !== '00000000-0000-0000-0000-000000000000') {
			this.removeRoot(sporttak.moederId, checkedSporttakken);
		}

		this.removeChildren(state.sporttakToDelete, checkedSporttakken);

		sporttakken = sporttakken.filter(m => checkedSporttakken.indexOf(m.id) > -1);

		model.sporttakken = sporttakken;

		context.setState({
			checkedSporttakken,
			showDeleteSporttakModal: false,
			level: -1,
			model
		});
	}

	closeDeleteSporttakModal() {
		this.context.setState({ showDeleteSporttakModal: false });
	}

	onClickDelete(id) {
		this.context.setState({ showDeleteSporttakModal: true, sporttakToDelete: id });
	}
}